import type { WithRequired } from 'admin';
import { type FullDemandSignalDTO, TradeSignalState, useApiTradeV1DemandSignalsList } from 'api';

import {
  MultiAutocompleteField,
  type MultiAutocompleteFieldProps,
} from '../MultiAutocompleteField/MultiAutocompleteField';

type Props = WithRequired<
  Omit<MultiAutocompleteFieldProps<FullDemandSignalDTO>, 'options' | 'isOptionEqualToValue'>,
  'getOptionLabel'
> & {
  materialId: number | undefined;
  materialFormIds: number[];
  buyerId?: number;
  country?: string;
  state?: TradeSignalState;
  materialGradeId?: number;
  materialSpecId?: number;
};

export const MultiUnmatchedDemandSignalAutocomplete = ({
  materialId,
  materialFormIds,
  buyerId,
  country,
  state = TradeSignalState.SIGNAL_IDENTIFIED,
  materialGradeId,
  materialSpecId,
  ...rest
}: Props) => {
  const { data, isLoading } = useApiTradeV1DemandSignalsList(
    {
      buyer_id: buyerId,
      country,
      material_form_ids: materialFormIds.length > 0 ? materialFormIds : undefined,
      material_grade_id: materialGradeId,
      material_id: materialId,
      material_spec_id: materialSpecId,
      state,
    },
    {
      query: {
        enabled: Boolean(materialId),
      },
    }
  );

  return (
    <MultiAutocompleteField<FullDemandSignalDTO>
      options={data || []}
      loading={isLoading}
      disabled={!materialId}
      valueField="id"
      isOptionEqualToValue={(option, value) => option.id === value.id}
      {...rest}
    />
  );
};
